import { render, staticRenderFns } from "./main-layout.vue?vue&type=template&id=b8700622"
import script from "./main-layout.vue?vue&type=script&lang=js"
export * from "./main-layout.vue?vue&type=script&lang=js"
import style0 from "./main-layout.vue?vue&type=style&index=0&id=b8700622&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8700622')) {
      api.createRecord('b8700622', component.options)
    } else {
      api.reload('b8700622', component.options)
    }
    module.hot.accept("./main-layout.vue?vue&type=template&id=b8700622", function () {
      api.rerender('b8700622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/main-layout.vue"
export default component.exports